import type { ApiClient } from "@/common/api/http/types";

interface ICsatAvailability {
  available: boolean;
}

export type CsatFeedbackQuestionId = "feedback_improvement" | "feedback_enjoyment";

export interface ICsatAnswers {
  rating: number;
  feedback_improvement?: string;
  feedback_enjoyment?: string;
}

export interface ICsatAnswersPayload {
  answers: ICsatAnswers;
  source?: string | null;
}

export default class CsatService {
  public constructor(private readonly client: ApiClient) {}

  async getAvailability(surveyId: string): Promise<ICsatAvailability> {
    return await this.client.get<ICsatAvailability>(`v2/csat/surveys/${surveyId}/availability`);
  }

  async submitAnswers(surveyId: string, payload: ICsatAnswersPayload): Promise<void> {
    return await this.client.post<void, ICsatAnswersPayload>(`v2/csat/surveys/${surveyId}/answers`, payload);
  }
}
